import { constants } from '@config';

import { LinkBuilder } from './link-types';

const template = require('./link.hbs');

module.exports = Backbone.View.extend({
  mode: 'url',

  isEditing: false,

  selectedUrlType: LinkBuilder.urlTypes[0].value,
  selectedPage: undefined,

  events: {
    'click .apply.btn': 'applyEvent',
    'click .remove.btn': 'removeEvent',
    'click .edit.btn': 'editEvent',
    'click [type=radio]': 'toggleEvent',
    'change [name="url-type"]': 'changeUrlTypeEvent',
    'keyup [name=url]': 'inputChangeEvent'
  },

  inputChangeEvent: function () {
    const element = this.$el.find('[name=url]').get(0);

    LinkBuilder.handleInputChange(element, this.selectedUrlType);
  },

  changeUrlTypeEvent: function (event) {
    const selectedUrlType = event.currentTarget.value;
    const element = this.$el.find('[name=url]').get(0);

    this.selectedUrlType = selectedUrlType;

    LinkBuilder.changeInputType(element, selectedUrlType);
  },

  removeEvent: function () {
    const isTextEditing = this.canvas.getMode() === 'textedit';

    for (const textDOM of this.canvas.getSelectedElems()) {
      const textarea = new INKIVE.Text.Textarea().setDOM(textDOM);

      if (!textarea) return;

      let range = !isTextEditing
        ? {
            start: 0,
            end: textarea.text.textContent.length
          }
        : this.canvas.runExtensions('selectionRange', {});

      if (range.start === range.end) {
        range = this.getLinkRange(textarea, range.start);
      }

      textarea.text.removeSpecificPartialStyling(range.start, range.end, 'link');
      textarea.text.removeSpecificPartialStyling(range.start, range.end, 'text-decoration');
      textarea.text.removeSpecificPartialStyling(range.start, range.end, 'fill', constants.text.hyperLink.fill);

      this.canvas.runExtensions('renderTextArea', { textArea: textarea });
    }

    INKIVE.DesignFacade.trigger('link.update');
  },

  editEvent: function () {
    const isAnchorMode = this.mode === 'anchor';

    this.render({
      isSet: false
    });

    this.isEditing = true;

    this.$el.find('[name=url]').toggleClass('disabled', isAnchorMode);
    this.$el.find('[name=anchor]').toggleClass('disabled', !isAnchorMode);

    this.$el.find('[name="url-type"]').toggleClass('disabled', isAnchorMode);
    this.$el.find('[name="link-type"]').toggleClass('disabled', !isAnchorMode);
  },

  getLinkRange: function (textarea, cursorPosition) {
    const styles = textarea.text.styles.filter(style => style.attribute === 'link');
    styles.sort((a, b) => a.start - b.start);

    let selectedIndex = -1;
    let selectedStyle = null;

    // get the selected style
    for (let i = 0; i < styles.length; i++) {
      const style = styles[i];
      if (style.start <= cursorPosition && style.end >= cursorPosition) {
        selectedIndex = i;
        selectedStyle = style;
        break;
      }
    }

    if (selectedStyle === null) {
      return {
        start: cursorPosition,
        end: cursorPosition
      };
    }

    let startStyle = null;
    let endStyle = null;

    // search backward
    for (let i = selectedIndex; i >= 1; i--) {
      const previousStyle = styles[i - 1];
      const currentStyle = styles[i];
      // if the previous style is not the same link or the previous style does not end right before the current style starts
      if (previousStyle.value !== selectedStyle.value || currentStyle.start !== previousStyle.end) {
        startStyle = currentStyle;
        break;
      }
    }

    // there is no non-match style before the selected style
    if (startStyle === null) {
      startStyle = styles[0];
    }

    // search forward
    for (let i = selectedIndex; i < styles.length - 1; i++) {
      const nextStyle = styles[i + 1];
      const currentStyle = styles[i];
      // if the next style is not the same link or the next style does not start right after the current style ends
      if (nextStyle.value !== selectedStyle.value || nextStyle.start !== currentStyle.end) {
        endStyle = currentStyle;
        break;
      }
    }

    // there is no non-match style after the selected style
    if (endStyle === null) {
      endStyle = styles[styles.length - 1];
    }

    return {
      start: startStyle.start,
      end: endStyle.end
    };
  },

  applyEvent: function () {
    const inputTarget = this.mode === 'url' ? '[name="url"]' : '[name="anchor"]';
    const value = this.$el.get(0).querySelector(inputTarget).value;
    const selectedType = this.getSelectedUrlType(value);
    const link = LinkBuilder.buildLink(selectedType, value);
    if (!link) return;

    const options = {
      shouldRemoveOverlappedStyles: true,
      skipHistory: true
    };

    const isTextEditing = this.canvas.getMode() === 'textedit';
    if (!isTextEditing) {
      for (const element of this.canvas.getSelectedElems()) {
        const textarea = new INKIVE.Text.Textarea().setDOM(element);
        if (!textarea) continue;

        const range = {
          start: 0,
          end: textarea.text.textContent.length
        };

        textarea.text.setPartialStyling(range.start, range.end, 'link', link, options);
        textarea.text.setPartialStyling(range.start, range.end, 'fill', constants.text.hyperLink.fill, options);
        textarea.text.setPartialStyling(range.start, range.end, 'text-decoration', 'underline', options);

        this.isEditing = false;

        this.canvas.runExtensions('renderTextArea', { textArea: textarea });
      }
      INKIVE.DesignFacade.trigger('link.update');
      return;
    }

    const textDOM = this.canvas.getSelectedElems()[0];
    const textarea = new INKIVE.Text.Textarea().setDOM(textDOM);

    if (!textarea) return;

    const range = this.canvas.runExtensions('selectionRange', {});

    if (range.start === range.end) {
      textarea.text.replaceOverlappedStyles('link', range.start, range.end, link);
    } else {
      textarea.text.setPartialStyling(range.start, range.end, 'link', link, options);
      textarea.text.setPartialStyling(range.start, range.end, 'fill', constants.text.hyperLink.fill, options);
      textarea.text.setPartialStyling(range.start, range.end, 'text-decoration', 'underline', options);
    }

    this.isEditing = false;

    this.canvas.runExtensions('renderTextArea', { textArea: textarea });
    INKIVE.DesignFacade.trigger('link.update');
  },

  toggleEvent: function (event) {
    const selectedOption = $(event.currentTarget).attr('value');
    const isChecked = $(event.currentTarget).is(':checked');

    if (isChecked) {
      this.mode = selectedOption;
    }

    this.$el.find('[name=url],[name=anchor]').addClass('disabled');
    this.$el.find('[name="' + selectedOption + '"]').toggleClass('disabled', !isChecked);

    const url = this.$el[0].querySelector('[name="url"]').value;
    const isSubmitAllowed = selectedOption === 'anchor' || LinkBuilder.isValidInput(url, this.selectedUrlType);

    const applyButton = this.$el[0].querySelector('.apply');
    applyButton.classList.toggle('disabled', !isSubmitAllowed);
  },

  initialize: function (options) {
    _.bindAll(this, 'updateTemplate');

    this.href = options.href;
    this.canvas = options.canvas;
    this.mode = LinkBuilder.getLinkType(this.href) === 'anchor' ? 'anchor' : 'url';

    this.render();
    INKIVE.EditorFacade.off('link.selection_changed').on('link.selection_changed', this.updateTemplate);
  },

  updateTemplate: function (buttonsFlagData) {
    if (buttonsFlagData.linkProcessed) return;

    buttonsFlagData.linkProcessed = true;

    this.href = buttonsFlagData.link === '' ? null : buttonsFlagData.link;
    this.mode = LinkBuilder.getLinkType(this.href) === 'anchor' ? 'anchor' : 'url';
    this.render();
  },

  getSelectedUrlType: function (url) {
    if (this.mode === 'anchor') return 'anchor';

    return this.selectedUrlType || LinkBuilder.getLinkType(url) || LinkBuilder.urlTypes[0].value;
  },

  render: function (options) {
    const anchor = this.href && this.href.indexOf('#') === 0 && this.href.replace('#', '');
    const url = !anchor && this.href;
    const isSet = options?.isSet ?? (anchor || url);
    this.selectedUrlType = this.getSelectedUrlType(this.href);
    const urlTypes = LinkBuilder.urlTypes.map((urlType) => ({
      ...urlType,
      selected: this.selectedUrlType === urlType.value
    }));
    const pages = LinkBuilder.getPages().map(page => ({
      value: page,
      selected: page === anchor
    }));

    const html = template({
      anchor,
      url: LinkBuilder.getLinkValue(url),
      is_valid: LinkBuilder.isValidInput(url, this.selectedUrlType),
      is_set: isSet,
      hide_pages: INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN ||
        INKIVE.C.BOOK.num_pages === 1,
      is_desygner: INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.DESYGNER_DESIGN,
      pages,
      urlTypes,
      selectedType: this.selectedUrlType
    });

    this.$el.html(html);
    anchor && this.$el.find('[name=anchor]').val(anchor);

    this.isEditing = false;
  }
});
